import classNames from 'classnames'
import CreatableSelectOriginal from 'react-select/creatable'

export default function CreatableSelect({ ...props }) {
  return <CreatableSelectOriginal {...props}
    classNames={{
      control: ({ isFocused }) => classNames('dark:!bg-neutral-800 dark:border-none dark:!text-white !shadow-none', { 'focus-visible': isFocused }),
      menu: () => 'dark:!bg-neutral-800 z-100000 dark:text-white',
      option: () => 'dark:bg-neutral-800 dark:hover:!bg-neutral-700',
      input: () => 'dark:!text-white',
      singleValue: () => 'dark:!text-white',
      multiValue: () => 'dark:!bg-neutral-600 dark:border-none dark:!text-white',
      multiValueLabel: () => 'dark:text-white',
      multiValueRemove: () => 'dark:hover:bg-red-600 dark:hover:text-white',
      ...props.classNames,
    }}
    styles={{
      control: (baseStyles, state) => ({...baseStyles, outline: false }),
      ...props.styles,
    }}
  />
}
